export interface NavTab {
  label: string;
  icon?: string;
  svgIcon?: string;
  badge?: string;
  route: string;
}

/**
 * Route data key used to declare navigation tabs on a route.
 */
export const NAV_TABS_KEY = 'navTabs';
